module.exports = __webpack_public_path__ + "static/media/IconMarker.e37a0771.svg";